// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__237Sh","productName":"Table_productName__1bvle"};